'use strict'

import { put, takeLatest } from 'redux-saga/effects'
import axios from '../../utils/axios'
import {
  SEND_EMAIL,
  SEND_EMAIL_SUPPORT,
  EMAIL_LIST,
  REQUESTED
} from '../types'

function *SendEmail({ payload }) {
  let config = {
    method: 'post',
    url: '/sendEmail',
    data: payload,
    headers: {
      Authenticate: true
    }
  }

  const result = yield axios(config, SEND_EMAIL)
  yield put(result)
}

function *SendEmailSupport({ payload }) {
  let config = {
    method: 'post',
    url: '/sendEmailSupport',
    data: payload,
    headers: {
      Authenticate: true
    }
  }

  const result = yield axios(config, SEND_EMAIL_SUPPORT)
  yield put(result)
}

function *EmailList({ payload }) {
  let config = {
    method: 'post',
    url: '/emailList',
    data: payload,
    headers: {
      Authenticate: true
    }
  }

  const result = yield axios(config, EMAIL_LIST)
  yield put(result)
}

module.exports = function *() {
  yield takeLatest(SEND_EMAIL + REQUESTED, SendEmail)
  yield takeLatest(SEND_EMAIL_SUPPORT + REQUESTED, SendEmailSupport)
  yield takeLatest(EMAIL_LIST + REQUESTED, EmailList)
}



// WEBPACK FOOTER //
// ./src/redux/sagas/email.js